import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PanToolIcon from '@mui/icons-material/PanTool';

const tooltip = (
  <Tooltip id="tooltip">Report an issue</Tooltip>
);
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    <div className="position-fixed fixed-bottom p-3">
      <div className="d-flex justify-content-end">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdS6RtKkqKVSrssO0THQrTVjAd2MKaC2Aa5Ge9n5cHHw0NrgA/viewform" target="_blank">
          <OverlayTrigger overlay={tooltip} placement="top">
            <PanToolIcon fontSize='medium'/>
          </OverlayTrigger>
        </a>
      </div>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
